module.exports = __webpack_public_path__ + "img/newbg.22e89fc.22e89fce.jpg";